(function () {
	if (!document.querySelector('.logo-carousel')) return;

	const swiper = new Swiper('.logo-carousel', {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 30,
		// centeredSlides: true,
		// Change the easing to 'cubic-bezier(0.5, 0, 0.5, 1)' for a more natural feel
		effect: 'slide',
		// Disable swiper
		// autoplay: false,
		speed: 800,
		fadeEffect: {
			crossFade: true,
		},

		autoplay: {
			delay: 3500,
			disableOnInteraction: true,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: '.carousel-next',
			prevEl: '.carousel-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 0,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 0,
			},
			1380: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
		},
	});
})();
